import { ShippingCountryState } from 'src/scripts/utils/shipping';
import { IS_NATIVE_APP_CLIENT } from '../../../../../utils/helpers';
import { ALO_API_HOST } from '../../../../../utils/constants';
import { getLocationInfo } from '../../../../../utils/location';

export const GWP_REMOVAL_FLAG_KEY = 'giftsRemovedByUser';

export const fetchGifts = async () => {
  if (!IS_NATIVE_APP_CLIENT) {
    const customerInfo = window.getCustomerInfo ? window.getCustomerInfo() : null;

    const locationInfo = await getLocationInfo();
    const countryCode = ShippingCountryState.countryCode ? ShippingCountryState.countryCode : locationInfo.country_code;

    const GWPendpoint = `${ALO_API_HOST}/v1/loyalty/gifts`;
    const gwpParams = new URLSearchParams({
      is_logged_in: (customerInfo?.isCustomer || false).toString(),
      country_code: countryCode || '',
    });
    const customerTags = customerInfo?.tags || [];
    customerTags.forEach((tag) => gwpParams.append('shopify_customer_tags', encodeURIComponent(tag)));
    const response = await fetch(GWPendpoint + '?' + gwpParams, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Alo-Sales-Channel': 'web',
      },
    });
    return response.json();
  }
};

export const memorizeGiftRemoval = (variantId: number) => {
  let removedGifts = [variantId.toString()];
  const existingGiftsRemovedByUser = localStorage?.getItem(GWP_REMOVAL_FLAG_KEY)?.split(',');
  if (existingGiftsRemovedByUser?.includes(variantId.toString())) return;

  if (existingGiftsRemovedByUser && existingGiftsRemovedByUser.length > 0)
    removedGifts = [...existingGiftsRemovedByUser, ...removedGifts];

  if (removedGifts) {
    localStorage.setItem(GWP_REMOVAL_FLAG_KEY, removedGifts.join());
  }
};
